import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import _ from 'helpers/no_conflict_lodash';

import SelectableRecordTable from 'components/selectable_record_table/selectable_record_table';
import SelectionDetails from 'components/selection_details';
import PersonRow from './person_row';
import PeopleTableHeader from './people_table_header';
import { changePersonPage, changePersonSort } from '../store/actions/query';
import { retrievePeople } from '../store/actions/search';
import { updatePreviewData } from '../store/actions/ui';
import {
  resetSelectedPeople,
  resetSelectedPeopleOnCurrentPage,
  toggleSelectAllPeople,
  toggleSelectAllPeopleOnCurrentPage
} from '../store/actions/select_list';

export class PeopleTable extends React.Component {
  static propTypes = {
    changePage: PropTypes.func.isRequired,
    changeSort: PropTypes.func.isRequired,
    contactPreviewProps: PropTypes.shape({
      displayActions: PropTypes.shape({
        slideOpen: PropTypes.string
      }).isRequired
    }).isRequired,
    people: PropTypes.array.isRequired,
    peopleIds: PropTypes.array.isRequired,
    previewOverlayCallId: PropTypes.bool,
    resetSelection: PropTypes.func.isRequired,
    resetSelectionOnCurrentPage: PropTypes.func.isRequired,
    retrievePeople: PropTypes.func.isRequired,
    selectedPersonIds: PropTypes.array.isRequired,
    setTags: PropTypes.func,
    sort: PropTypes.string,
    toggleSelectAll: PropTypes.func.isRequired,
    toggleSelectAllOnCurrentPage: PropTypes.func.isRequired,
    updatePreviewData: PropTypes.func
  };

  allSelected() {
    return _.every(this.props.people, person => this.isSelected(person.id));
  }

  someSelected() {
    return _.some(this.props.people, person => this.isSelected(person.id)) && this.props.people.length > 0;
  }

  includeSearchResults() {
    const { people } = this.props;
    return people && people.length > 0 && people[0].searchResults != null;
  }

  isSelected(personId) {
    return this.props.selectedPersonIds.indexOf(personId) > -1;
  }

  handleSortChange = (sortOption) => {
    const { changePage, changeSort, retrievePeople } = this.props;

    changeSort(sortOption);
    changePage(1);
    retrievePeople();
  };

  canPreview = () => {
    const {
      previewOverlayCallId
    } = this.props;

    return !previewOverlayCallId;
  };

  handleUpdatePreviewOverlay = (personId) => {
    const {
      contactPreviewProps,
      updatePreviewData
    } = this.props;

    if (!this.canPreview()) return null;

    const { displayActions: { slideOpen } } = contactPreviewProps;

    updatePreviewData(personId, "Contacts::Person");
    window[slideOpen]();
    sessionStorage.setItem("previewDisplay", true);
  };

  render() {
    const columnHeaders = (
      <PeopleTableHeader
        includeSearchResults={this.includeSearchResults()}
        sort={this.props.sort}
        onSortChange={this.handleSortChange}
      />
    );

    return (
      <SelectableRecordTable
        columnHeaders={columnHeaders}
        selectAllChecked={this.allSelected(this.state)}
        selectNoneVisible={this.someSelected()}
        onResetSelection={this.props.resetSelectionOnCurrentPage}
        onSelectAllToggle={this.props.toggleSelectAllOnCurrentPage}
      >
        <SelectionDetails
          forTable
          label="contact"
          selectedCount={this.props.selectedPersonIds.length}
          totalCount={this.props.peopleIds.length}
          onClearSelection={this.props.resetSelection}
          onSelectAll={this.props.toggleSelectAll}
        />
        {this.renderPeople()}
      </SelectableRecordTable>
    );
  }

  renderPeople() {
    return _.map(this.props.people, person => (
      <PersonRow
        canPreview={this.canPreview}
        key={person.id}
        person={person}
        selected={this.isSelected(person.id)}
        updatePreviewOverlay={this.handleUpdatePreviewOverlay}
      />
    ));
  }
}

const mapStateToProps = state => ({
  contactPreviewProps: state.ui.contactPreviewProps,
  people: state.search.people,
  peopleIds: state.search.meta.people.allIds,
  previewOverlayCallId: state.ui.previewOverlayCallId,
  selectedPersonIds: state.selectList.selectedPersonIds,
  sort: state.query.personSort
});

const mapDispatchToProps = {
  retrievePeople,
  updatePreviewData,

  changePage: changePersonPage,
  changeSort: changePersonSort,
  resetSelection: resetSelectedPeople,
  resetSelectionOnCurrentPage: resetSelectedPeopleOnCurrentPage,
  toggleSelectAll: toggleSelectAllPeople,
  toggleSelectAllOnCurrentPage: toggleSelectAllPeopleOnCurrentPage
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleTable);
